/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-20T12:07:15.835
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listAuthFuncRoleManage,
	listAuthFuncRoleManageInit,
	listAuthFuncRoleManageByAuthorizations,
	deleteAuthFuncRoleManage
} from '@api/systemmanage/AuthFuncRoleManage';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		UserRoleList:[],
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listAuthFuncRoleManage({
			state
		}) {
			return new Promise((resolve, reject) => {
				listAuthFuncRoleManage(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listAuthFuncRoleManageByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listAuthFuncRoleManageByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listAuthFuncRoleManageInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listAuthFuncRoleManageInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteAuthFuncRoleManage({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteAuthFuncRoleManage({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
